import React from 'react'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

export default class DriverLocations extends React.Component {
  renderDriverMarker = driver => (
    <MarkerWithLabel
      key={driver.tel}
      location={driver.location}
      icon={helpers.getIconByStatus(driver.status)}
      label={`${driver.family_name} ${driver.first_name}`}
      labelColor={helpers.getLabelColor(driver.status)}
    />
  )

  render() {
    const { drivers, driverType } = this.props
    const availableDrivers = []

    const driverKeys = Object.keys(drivers)
    const driverCount = driverKeys.length

    for (let i = 0; i < driverCount; i += 1) {
      const driverKey = driverKeys[i]
      const driver = drivers[driverKey]

      if ((driverType === 'all' || driver.status === 'available') && driver.online && driver.location) {
        availableDrivers.push(this.renderDriverMarker(driver))
      }
    }

    return availableDrivers
  }
}



// WEBPACK FOOTER //
// ./src/containers/mapView/components/DriverLocations.js